import { TCategoriesTree } from '@typings'

/** Cast categories tree to Antd Tree component format. */
export const prepareCategoriesTree = (data: TCategoriesTree = []): any =>
	data.map((category) => ({
		...category,
		key: String(category.id),
		children: prepareCategoriesTree(category.subcategories),
	}))
